import '../NewCreationUI.css'
import React from 'react'
import { theme } from '../../Common/Credentials'

const OSSwitch = React.forwardRef(({
    checked,
    onChange,
    disabled = false,
    size = "md",
    ...props
}, ref) => {
    const handleClick = (e) => {
        e.stopPropagation()
        if (!disabled && onChange) {
            onChange(!checked)
        }
    }

    const handleKeyDown = (e) => {
        if (disabled) return

        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault()
            onChange(!checked)
        }
    }

    return (
        <div
            ref={ref}
            className={`os-switch ${size} ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="switch"
            aria-checked={checked}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            style={{
                '--switch-active-color': theme === "classic" ? "#4d4d4d" : "#2563eb",
                // '--switch-inactive-color': inactiveColor,
                // '--switch-thumb-color': thumbColor,
            }}

            {...props}
        >
            <div className={"os-switch-track"}>
                <div className="os-switch-thumb" />
            </div>
        </div>
    )
})

OSSwitch.displayName = 'OSSwitch'

export { OSSwitch }